// MARK: NPM Modules
import React from "react";
import styled from "styled-components";
// MARK: Styled Components

const Icon = styled.img`
  width: 33.3151px;
  height: 25px;
`;
// MARK: React Component
// Props
interface Props {}
// Styleguide & Datapoints
// Component
function MailIcon({}: Props) {
  // MARK: React Redux Variables
  // MARK: Render
  return <Icon src="/Mail.webp" alt="An icon of an email." />;
}

export default MailIcon;
